import {PromoCodeErrorResponse, PromoCodeError} from '@domain/model/PromoCode/PromoCodeError';

const ErrorPromoLimit = 'PROMO_CODE_REACHED_LIMIT_USES';
const ErrorPromoFirstOrder = 'PROMO_CODE_FOR_FIRST_ORDER';
const ErrorPromoExpired = 'PROMO_CODE_EXPIRED';
const ErrorPromoOneCode = 'PROMO_CODE_ONE_CODE';
const PromoCodeForSubs = 'PROMO_CODE_FOR_SUBS';
const PromoCodeForDemand = 'PROMO_CODE_FOR_DEMAND';
export const PromoNotApplyToService = 'PROMO_NOT_APPLY_TO_SERVICE';
export const UnexpectedErrorCode = 'UNEXPECTED_ERROR_CODE';

const PromoCodeErrorMap = {
  [ErrorPromoLimit]: ['PSA-005'],
  [ErrorPromoFirstOrder]: ['PSA-006'],
  [ErrorPromoExpired]: ['PSA-010', 'PSA-004'],
  [ErrorPromoOneCode]: ['PSA-011'],
  [PromoCodeForSubs]: ['PSA-007'],
  [PromoNotApplyToService]: ['PSA-025'],
  [PromoCodeForDemand]: ['PSA-026'],
};

const getErrorCode = (errorCode: string): string =>
  Object.entries(PromoCodeErrorMap).reduce((result, errors) => {
    if (errors[1].includes(errorCode)) {
      result = errors[0];
    }
    return result;
  }, UnexpectedErrorCode);

const isPromoCodeErrorResponse = (e: PromoCodeErrorResponse | Error): e is PromoCodeErrorResponse =>
  (e as PromoCodeErrorResponse).error_code !== undefined;

export const parseError = (e: PromoCodeErrorResponse | Error): never => {
  if (!e) {
    throw new PromoCodeError('', UnexpectedErrorCode);
  }
  if (isPromoCodeErrorResponse(e)) {
    throw new PromoCodeError(e.error_message, getErrorCode(e.error_code), e.error_code, e.timestamp);
  }
  throw new PromoCodeError(e.message, UnexpectedErrorCode);
};
